import React from 'react';
import {Switch, FormControlLabel} from "@material-ui/core";

import './styles.scss';

import LabelDisplay from "../LabelDisplay";
import inputCtor from "../../utils/inputCtor";

const Input = ({
 id,
 name,
 onChange,
 value,
 text,
 disabled
}) => (
  <FormControlLabel
    control={
      <Switch
        id={`${id}Input`}
        checked={value || false}
        onChange={(e) => {
          onChange(name, e.target.checked)
        }}
        disabled={disabled}
      />
    }
    label={text}
  />
);

const Component = ({
 className,
 text,
 labelProps,
 inputProps,
 errorProps
}) => {
  return (
    <div
      id={inputProps.id}
      className={[
        'merchant-field',
        'merchant-switch',
        inputProps.value ? 'checked' : '',
        inputProps.disabled ? ' disabled' : '',
        errorProps.showError ? ' error' : '',
        className
      ].join(' ')}
    >
      <LabelDisplay {...labelProps} />
      <Input {...inputProps} text={text} />
    </div>
  )
}

export default inputCtor(Component);
